module.exports = __webpack_public_path__ + "static/media/info.3fa109d9.svg";